<template lang="pug">
  a.preview-video(
    href="#"
    @click.prevent.stop
    v-touch:tap="($event) => $emit('maximize', { event: $event, media })"
    @mouseover.prevent.stop="focus"
    @mouseleave.prevent.stop="leave"
  )
    figure.video(
      :style="style"
    )
      video(
        ref="player"
        class="video-js vjs-city-offer vjs-show-big-play-button-on-pause minimalistic"
        controls
        playsinline
        preload="auto"
        :style="{ width: `${width - 2}px`, height: `${height - 2}px` }"
      )
        source(:src="src" :type="mime")
</template>

<script>
import { get, trim } from '@/helpers';
import { mapMutations } from 'vuex';

import videojs from 'video.js';
import 'videojs-http-source-selector';
import 'videojs-contrib-quality-levels';

export default {
    name: 'PreviewVideo',
    props: {
        media: {
            type: Object,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        width: {
            type: Number,
            default: 120
        },
        aspectRatio: {
            type: Number
        }
    },
    computed: {
        height() {
            let height;
            if (this.aspectRatio) height = this.width / this.aspectRatio;
            else height = this.width / (this.media.video.width / this.media.video.height);
            return height;
        },
        style() {
            return {
                width: `${this.width}px`,
                height: `${this.height}px`
            };
        },
        isHls() {
            return !!get(this.media, 'video.hls');
        },
        mime() {
            let mime = get(this.media, 'video.source.mime');
            if (this.isHls) {
                mime = get(this.media, 'video.hls.mime');
            }
            return mime;
        },
        src() {
            let src;
            if (this.media.video) {
                // if (this.isHls) {
                //   src = `${cdnEndpoint}/${this.media.video.hls.path}/${this.media.video.hls.name}`;
                // } else {
                //   src = `${cdnEndpoint}/${this.media.video.source.path}/${this.media.video.source.name}`;
                // }

                const storageRoute = trim(
                    `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                    '/'
                );

                if (this.isHls) {
                    // src = `${storageRoute}/videos/${this.media.video.id}/${this.media.video.hls.name}`;

                    const cdnEndpoint = trim(
                        `${process.env.VUE_APP_CDN_HTTP}${process.env.VUE_APP_CDN_ENDPOINT}${process.env
                            .VUE_APP_CDN_ROOT || ''}`,
                        '/'
                    );

                    src = `${cdnEndpoint}/${this.media.video.hls.path}/${this.media.video.hls.name}`;
                } else {
                    src = `${storageRoute}/videos/${this.media.video.id}/${this.media.video.source.name}`;
                }
            }

            return src;
        },
        options() {
            return {
                muted: true,
                language: 'en',
                preload: 'auto',
                fluid: true,
                aspectRatio: `${parseInt(this.width)}:${parseInt(this.height)}`,
                // autoplay: true,
                // inactivityTimeout: 1,
                html5: {
                    hls: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions: true,
                        useDevicePixelRatio: true,
                        bandwidth: 16777216
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false,
                    useBandwidthFromLocalStorage: true
                },
                controlBar: {
                    pictureInPictureToggle: false
                }
                // plugins: {
                //   hlsQualitySelector: {
                //     displayCurrentQuality: true,
                //   }
                // }
            };
        }
    },
    methods: {
        focus() {
            this.setFocusedMedia({ product: this.product, media: this.media });
        },
        leave() {
            this.removeFocusedMedia();
        },
        initialise() {
            this.player = videojs(this.$refs.player, this.options);
            this.player.httpSourceSelector();

            // this.player.controls(false)

            this.player.on('ended', () => {
                this.player.posterImage.show();
                // vid.bigPlayButton.show();
                this.player.currentTime(0);
            });

            this.player.on('play', () => {
                this.player.pause();
                this.player.currentTime(0);
                // this.$emit('maximize', {event, media: this.media });
            });

            videojs.log.level('error');
        },
        ...mapMutations({
            setFocusedMedia: 'shop/setFocusedMedia',
            removeFocusedMedia: 'shop/removeFocusedMedia'
        })
    },
    mounted() {
        if (this.width && this.height) {
            // console.log(`${this.width}:${this.height}`);
            this.initialise();
        }
    },
    beforeDestroy() {
        if (this.player) this.player.dispose();
    }
};
</script>

<style lang="sass" scoped>
.preview-video
  background: black
.video
  @apply bg-gray-200
  overflow: hidden
  border: 1px solid var(--color-primary)
  background-position: center
  background-repeat: no-repeat
  background-size: cover
  ::v-deep
    .vjs-volume-panel,
    .vjs-menu-button.vjs-http-source-selector
      display: none
    .vjs-control-bar
      display: none

    .video-js
      background: transparent
      .vjs-big-play-button
        display: initial
      // &.vjs-playing
        .vjs-big-play-button
          display: none
</style>
